import { render, staticRenderFns } from "./profile-sidebar.vue?vue&type=template&id=173b8991&scoped=true"
import script from "./profile-sidebar.vue?vue&type=script&lang=js"
export * from "./profile-sidebar.vue?vue&type=script&lang=js"
import style0 from "./profile-sidebar.vue?vue&type=style&index=0&id=173b8991&prod&scoped=true&lang=scss"
import style1 from "./profile-sidebar.vue?vue&type=style&index=1&id=173b8991&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173b8991",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileGallery: require('/app/components/profile/profile-gallery.vue').default,CLoader: require('/app/components/ui/c-loader.vue').default,IconHeartLightGray: require('/app/components/icons/IconHeartLightGray.vue').default,IconNote: require('/app/components/icons/IconNote.vue').default,VExpansionPanelHeader: require('/app/node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanelHeader.js').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,VExpansionPanelContent: require('/app/node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanelContent.js').default,VExpansionPanel: require('/app/node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanel.js').default,IconCalendarCheck: require('/app/components/v2/icons/IconCalendarCheck.vue').default,IconNotePen: require('/app/components/icons/IconNotePen.vue').default,IconPencilXRuler: require('/app/components/icons/IconPencilXRuler.vue').default,VRating: require('/app/node_modules/vuetify/lib/components/VRating/VRating.js').default,IconLocationMarker: require('/app/components/icons/IconLocationMarker.vue').default,IconPhoneDialogue: require('/app/components/icons/IconPhoneDialogue.vue').default,VExpansionPanels: require('/app/node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanels.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VBtn,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VIcon,VRating})
